import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ClientPlanResponse, CreateClientPlanRequest } from '../types/domain';

export function clientPlanEndpoints(http: HttpClient) {
  return {
    listByClient: (clientId: string) => http.get<ApiEnvelope<ClientPlanResponse[]>>(`/v1/client-plans/${clientId}`).then(unwrap),
    assign: (body: CreateClientPlanRequest) => http.post<ApiEnvelope<ClientPlanResponse>>('/v1/client-plans', body).then(unwrap),
  };
}
export type ClientPlanEndpoints = ReturnType<typeof clientPlanEndpoints>;
